/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/models';
import { GenericResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface CittadinoAccountServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Cancella il proprio account (anonimizzazione irreversibile).
     * Audience: CITTADINO autenticato. Azzera i dati personali dell\&#39;identita\&#39; e del profilo, disabilita l\&#39;account in Keycloak e revoca le sessioni attive. Le pratiche presentate NON vengono cancellate e restano consultabili dal Comune. Operazione irreversibile: l\&#39;account non e\&#39; recuperabile e un accesso successivo con la stessa identita\&#39; digitale genera un account nuovo, senza storico. Dopo una risposta 200 il client deve smontare la sessione locale senza chiamare il logout (le sessioni sono gia\&#39; state revocate lato server).
     * @endpoint delete /api/v1/cittadino/account
*/
    eliminaAccountCittadino(extraHttpRequestParams?: any): Observable<GenericResponseDTO>;

}
